import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

const Error404 = ({ history }) => (
  <Card className="text-center">
    <CardBody className="p-5">
      <div className="display-1 text-200 fs-error">404</div>
      <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
        No encontramos la página que estás buscando.
      </p>
      <hr/>
      <p>
        Asegurate de que la <b>dirección que has introducido es la correcta</b> y la pagina no se ha transladado a otro sitio web. Si crees que esto es un error,
        <Link to="mailto:info@exmaple.com" className="ml-1">
          Contactanos
        </Link>
        .
      </p>
      <Button className="btn btn-primary btn-sm mt-3" onClick={()=>history.goBack()}>
        <FontAwesomeIcon icon="arrow-left" className="mr-2" />
        Volver atras
      </Button>
    </CardBody>
  </Card>
);

export default withRouter(Error404);